var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "components-container" },
    [
      _c(
        "el-form",
        { ref: "pram", attrs: { "label-width": "110px", model: _vm.pram } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "归属公司：",
                prop: "companyId",
                rules: [
                  {
                    required: true,
                    message: "请选择归属公司",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("SelectCompay", {
                attrs: { outName: true, initCompanyId: _vm.details.companyId },
                on: {
                  change: _vm.selectCompany,
                  selectCompany: _vm.selectCompany,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "供应商名称：",
                prop: "supplierName",
                rules: [
                  {
                    required: true,
                    message: "请填写供应商名称",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写供应商名称" },
                model: {
                  value: _vm.pram.supplierName,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "supplierName", $$v)
                  },
                  expression: "pram.supplierName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "登录账号：",
                prop: "account",
                rules: [
                  {
                    required: true,
                    message: "请填写登录账号",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写登录账号" },
                model: {
                  value: _vm.pram.account,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "account", $$v)
                  },
                  expression: "pram.account",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "登录密码：",
                prop: "password",
                rules: [
                  {
                    required: true,
                    message: "请填写登录密码",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写登录密码" },
                model: {
                  value: _vm.pram.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "password", $$v)
                  },
                  expression: "pram.password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "合作状态：",
                prop: "cooperationStatus",
                rules: [
                  {
                    required: true,
                    message: "请选择合作状态",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { clearable: "", placeholder: "请选择合作状态" },
                  model: {
                    value: _vm.pram.cooperationStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "cooperationStatus", $$v)
                    },
                    expression: "pram.cooperationStatus",
                  },
                },
                _vm._l(_vm.typeOpetion, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.name, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "票务类型：",
                prop: "ticketType",
                rules: [
                  {
                    required: true,
                    message: "请选择票务类型",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.pram.ticketType,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "ticketType", $$v)
                    },
                    expression: "pram.ticketType",
                  },
                },
                _vm._l(_vm.cardOpetion, function (item) {
                  return _c(
                    "el-radio",
                    { key: item.value, attrs: { label: item.value } },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "结算方式：",
                prop: "settlementMethodText",
                rules: [
                  {
                    required: true,
                    message: "请填写结算方式",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 2,
                  resize: "none",
                  placeholder: "请详细描述结算方式",
                },
                model: {
                  value: _vm.pram.settlementMethodText,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "settlementMethodText", $$v)
                  },
                  expression: "pram.settlementMethodText",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showWriteOffType
            ? _c(
                "el-form-item",
                { attrs: { label: "核销方式", prop: "writeOffType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.pram.writeOffType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "writeOffType", $$v)
                        },
                        expression: "pram.writeOffType",
                      },
                    },
                    _vm._l(_vm.verificationOption, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.supplierType == 4
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "LOGO：", prop: "logo" } },
                  [
                    _c(
                      "div",
                      { staticClass: "upload-row" },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "logo-uploader",
                            attrs: {
                              action: "",
                              "show-file-list": false,
                              "http-request": _vm.handleLogoUpload,
                              "before-upload": _vm.beforeLogoUpload,
                              accept: "image/png,image/jpeg,image/jpg",
                            },
                          },
                          [
                            _vm.pram.logo
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", { attrs: { src: _vm.pram.logo } }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "upLoad-tip" }, [
                                    _vm._v("点击上传"),
                                  ]),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.pram.logo
                          ? _c("i", {
                              staticClass: "el-icon-delete remove-icon",
                              on: { click: _vm.removeLogo },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-tip" }, [
                      _vm._v("建议尺寸 200×200，支持 png/jpg，大小不超过 2MB"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "核销配置：", prop: "miniProgramList" } },
                  [
                    _c(
                      "div",
                      { staticClass: "mini-program-form" },
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "mini-program-table",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.pram.miniProgramList,
                              border: "",
                              "row-class-name": "mini-program-table-row",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "index",
                                label: "序号",
                                width: "60",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "归属小程序",
                                "min-width": "220",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "mini-cell-form",
                                            attrs: {
                                              prop:
                                                "miniProgramList." +
                                                scope.$index +
                                                ".customerId",
                                              rules: [],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  placeholder:
                                                    "请选择归属小程序",
                                                  filterable: "",
                                                  clearable: "",
                                                },
                                                on: {
                                                  change: function (val) {
                                                    return _vm.onCustomerChange(
                                                      val,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.customerId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "customerId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.customerId",
                                                },
                                              },
                                              _vm._l(
                                                _vm.customerOptions,
                                                function (opt) {
                                                  return _c("el-option", {
                                                    key: opt.id,
                                                    attrs: {
                                                      label: opt.name,
                                                      value: opt.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4019046105
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "核销跳转链接",
                                "min-width": "280",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "mini-cell-form",
                                            attrs: {
                                              prop:
                                                "miniProgramList." +
                                                scope.$index +
                                                ".designAuthId",
                                              rules: [],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  placeholder:
                                                    "请选择核销跳转链接",
                                                  filterable: "",
                                                  clearable: "",
                                                },
                                                on: {
                                                  change: function (val) {
                                                    return _vm.onDesignAuthChange(
                                                      val,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.designAuthId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "designAuthId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.designAuthId",
                                                },
                                              },
                                              _vm._l(
                                                _vm.designAuthOptions,
                                                function (opt) {
                                                  return _c("el-option", {
                                                    key: opt.designAuthId,
                                                    attrs: {
                                                      label: opt.designAuthName,
                                                      value: opt.designAuthId,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1197359000
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "操作",
                                width: "100",
                                align: "center",
                                fixed: "right",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "#f56c6c" },
                                            attrs: {
                                              type: "text",
                                              icon: "el-icon-delete",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeMiniProgram(
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2333978778
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "add-mini-btn",
                            attrs: {
                              type: "primary",
                              plain: "",
                              icon: "el-icon-plus",
                            },
                            on: { click: _vm.addMiniProgram },
                          },
                          [_vm._v("新增一组核销配置")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.supplierType == 3
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "提前预约：", prop: "advanceReservation" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _vm._v("\n\t\t\t\t\t\t需提前"),
                        _c("el-input-number", {
                          staticStyle: { margin: "0 10px" },
                          attrs: { min: 0 },
                          model: {
                            value: _vm.pram.advanceReservation,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "advanceReservation", $$v)
                            },
                            expression: "pram.advanceReservation",
                          },
                        }),
                        _vm._v("小时预约\n\t\t\t\t\t"),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "服务时间：", prop: "serviceTimes" } },
                  [
                    _c("TimeSelect", {
                      model: {
                        value: _vm.pram.serviceTimes,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "serviceTimes", $$v)
                        },
                        expression: "pram.serviceTimes",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "对接人：", prop: "contactName" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写对接人" },
                model: {
                  value: _vm.pram.contactName,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "contactName", $$v)
                  },
                  expression: "pram.contactName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "对接人职位：", prop: "contactPosition" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写对接人职位" },
                model: {
                  value: _vm.pram.contactPosition,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "contactPosition", $$v)
                  },
                  expression: "pram.contactPosition",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "对接人电话：", prop: "contactPhone" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写对接人电话" },
                model: {
                  value: _vm.pram.contactPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "contactPhone", $$v)
                  },
                  expression: "pram.contactPhone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.miniProgramCustomer
            ? _c(
                "el-form-item",
                { attrs: { label: "维护人：", prop: "maintainerId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        placeholder: "请选择维护人",
                        filterable: "",
                        "filter-method": _vm.handleUserSearch,
                      },
                      model: {
                        value: _vm.pram.maintainerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "maintainerId", $$v)
                        },
                        expression: "pram.maintainerId",
                      },
                    },
                    _vm._l(_vm.userOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label:
                            "" +
                            item.realName +
                            (item.flag == 1 ? "（当前登陆人）" : ""),
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "微信群名称：", prop: "weChatGroupName" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写微信群名称" },
                model: {
                  value: _vm.pram.weChatGroupName,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "weChatGroupName", $$v)
                  },
                  expression: "pram.weChatGroupName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.supplierType == 4
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "供货折扣率",
                      prop: "discountRate",
                      rules: [
                        {
                          required: true,
                          message: "请填写供货折扣率",
                          trigger: ["blur", "change"],
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            min: 1,
                            max: 100,
                            step: 1,
                            "controls-position": "right",
                          },
                          model: {
                            value: _vm.pram.discountRate,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "discountRate", $$v)
                            },
                            expression: "pram.discountRate",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "margin-left": "6px" } }, [
                          _vm._v("%"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          color: "#909399",
                          "font-size": "12px",
                          "margin-top": "6px",
                        },
                      },
                      [
                        _vm._v("填写整数百分比，例如填写 "),
                        _c("strong", [_vm._v("80")]),
                        _vm._v(" 表示 "),
                        _c("strong", [_vm._v("80%")]),
                        _vm._v("（8折）。"),
                      ]
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "备注：", prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  type: "textarea",
                  rows: 2,
                  resize: "none",
                  placeholder: "备注",
                },
                model: {
                  value: _vm.pram.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "remark", $$v)
                  },
                  expression: "pram.remark",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", [
            _c(
              "div",
              { staticStyle: { "text-align": "right" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.loading },
                    on: {
                      click: function ($event) {
                        return _vm.handerSubmit("pram")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }